module.exports = __webpack_public_path__ + "img/52.2.TN.18bdc896.png";